import { render, staticRenderFns } from "./PageBtn.vue?vue&type=template&id=b79d113a&"
import script from "./PageBtn.vue?vue&type=script&lang=js&"
export * from "./PageBtn.vue?vue&type=script&lang=js&"
import style0 from "./PageBtn.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports